module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/player-detail/player-detail.component.css
// module id = ./src/app/player-detail/player-detail.component.css
// module chunks = main